import { render, staticRenderFns } from "./HomeTrivia.vue?vue&type=template&id=d97b0c5e&scoped=true"
import script from "./HomeTrivia.vue?vue&type=script&lang=js"
export * from "./HomeTrivia.vue?vue&type=script&lang=js"
import style0 from "./HomeTrivia.vue?vue&type=style&index=0&id=d97b0c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97b0c5e",
  null
  
)

export default component.exports